import { Widget } from '@/types'
import { CldImage } from 'next-cloudinary'
import Link from 'next/link'
import React, { useState } from 'react'
import { LanguageSwitcher } from '../../language-switcher'
import { useRouter } from 'next/router'
import CartDrawer from '@/components/create-order/cart-drawer'
import { useIsInIframe } from '@/helper/utils'
import { Button } from '../../ui/button'
import { ArrowLeft } from 'lucide-react'

const AppNavbar = ({ widget }: { widget: Widget }) => {
  const router = useRouter()
  const [firstPage] = useState(router.pathname)
  const inIframe = useIsInIframe()

  const canGoBack = firstPage !== router.pathname

  return (
    <header className="bg-white fixed w-full md:block top-0 z-50">
      <div className="flex items-center justify-between p-4 max-w-7xl mx-auto">
        <div className="flex items-center space-x-2">
          {inIframe && canGoBack && (
            <Button variant="ghost" size="icon" onClick={() => router.back()}>
              <ArrowLeft />
            </Button>
          )}
          {!inIframe && (
            <Link
              href={`/app/widgets/${widget.uuid}`}
              className="flex items-center space-x-2"
            >
              <CldImage
                src={widget.company.logo}
                alt={widget.company.name}
                width="32"
                height="32"
              />
              <span className="ml-2 font-semibold">{widget.company.name}</span>
            </Link>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <CartDrawer
            goToCart={inIframe ? () => router.push(`/app/cart`) : undefined}
            checkoutUrl={`/app/checkout`}
          />
          <LanguageSwitcher supportedLocales={widget.supportedLocales} />
        </div>
      </div>

      <div className="relative md:absolute md:left-1/2 md:-translate-x-1/2 md:top-2"></div>
    </header>
  )
}

export default AppNavbar
